<template>
  <div v-if="isRouterAlive" id="app">
    <a-config-provider :locale="zh_CN">
      <router-view v-show="pageInit" />
    </a-config-provider>
    <div v-show="!pageInit" class="page-wait-container">
      <a-spin :spinning="true" />
      <div>正在加载资源</div>
      <div>如果2分钟还没进入页面，或许可以刷新试试</div>
    </div>
  </div>
</template>

<script>
import storageUtils from '@/utils/storageUtils'
import {
  getOs,
  getPlatformTypeByUserAgent,
  getBrowserName
} from '@/utils/userAgentUtil.js'
import createUuid from '@/utils/uuid'
import { getUserInfo } from '@/pages/login/request'
import { SUCC_CODE } from '@/utils/constants'
// import SmallMedia from '@/components/smallMedia'
import { mapState } from 'vuex'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      pageLoading: true,
      zh_CN
    }
  },
  computed: {
    ...mapState(['pageInit'])
  },
  created() {
    const BrowserName = getBrowserName(navigator.userAgent)
    if (navigator && BrowserName === 'ie') {
      return this.$router.replace('/ie-page')
    }
  },
  mounted() {
    this.setHeader()
    this.updateUser()
    window.addEventListener('tokenError', () => this.reLogin())
  },
  methods: {
    reload() {
      // 重新加载
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    // vuex注入用户信息
    async updateUser() {
      // 获取userInfo
      let user = storageUtils.getUser()
      if (user && user.userInfo) {
        const getUserInfoRes = await getUserInfo()
        if (getUserInfoRes.code === SUCC_CODE) {
          let newUserInfo = getUserInfoRes.result.userInfo.base
          let userInfo = user.userInfo
          newUserInfo.authGroupIds = userInfo.authGroupIds
          newUserInfo.auths = userInfo.auths
          user.userInfo = newUserInfo
          storageUtils.saveUser(user)
          this.$store.dispatch('actionSetUser', user)
          // this.user = getUserInfoRes.result.userInfo
          // this.loadIconfont()
        } else {
          this.$message.error(getUserInfoRes.msg)
        }
      }
    },
    setHeader() {
      // 设置头部初始值
      const user_agent = navigator.userAgent
      // 语言
      this.getHeaderLang()
      // osVersion
      this.getHeaderOsVersion(user_agent)
      // platformType
      this.getPlatFormType(user_agent)
      // deviceId
      this.getDeviceId()
    },
    // // 动态加载iconfont
    // loadIconfont() {
    //   // 创建一个新的 style 元素
    //   const styleElement = document.createElement('style')
    //   // 为 style 元素设置 ID
    //   styleElement.setAttribute('id', 'iconfont-styles')
    //   // 定义样式内容
    //   const styles = `
    //       @font-face {
    //         font-family: 'iconfont';  /* Project id 2623699 */
    //         src: url('//at.alicdn.com/t/c/font_2623699_ycoozbawsu.woff2?t=1701938072960') format('woff2'),
    //             url('//at.alicdn.com/t/c/font_2623699_ycoozbawsu.woff?t=1701938072960') format('woff'),
    //             url('//at.alicdn.com/t/c/font_2623699_ycoozbawsu.ttf?t=1701938072960') format('truetype');
    //       }
    //   `
    //   // 将样式内容添加到 style 元素中
    //   styleElement.appendChild(document.createTextNode(styles))

    //   // 将 style 元素添加到文档的 head 中
    //   document.head.appendChild(styleElement)
    // },
    getDeviceId() {
      // 设备id
      const deviceId = storageUtils.getDeviceId()
      if (!deviceId) {
        const newDeviceId = createUuid()
        storageUtils.saveDeviceId(newDeviceId)
      }
    },
    getPlatFormType(user_agent) {
      // 头部设备类型
      const plat = storageUtils.getPlatformType()
      if (!plat) {
        const newPlat = getPlatformTypeByUserAgent(user_agent)
        storageUtils.savePlatformType(newPlat)
      }
    },
    getHeaderOsVersion(user_agent) {
      // 头部操作系统版本
      const osVersion = storageUtils.getOsVersion()
      if (!osVersion) {
        const newOsVersion = getOs(user_agent)
        storageUtils.saveOsVersion(newOsVersion)
      }
    },
    getHeaderLang() {
      // 头部语言
      const lang = 1
      const oldLang = storageUtils.getLang()
      if (!lang || lang !== oldLang) {
        storageUtils.saveLang(lang)
      }
    },
    reLogin() {
      // 重新登录
      storageUtils.removeToken()
      storageUtils.removeUserId()
      storageUtils.removeUser()
      this.$message.info('登录信息已过期，请重新登录')
      setTimeout(() => {
        this.$router.replace({ path: '/login' })
      }, 1000)
    }
  }
}
</script>

<style lang="less">
@import './assets/css/main.less';
.page-wait-container {
  width: 100vw;
  height: 100vh;
  background-color: #000;
  font-size: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
